// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PRotateRightOutlinedSvg from "@fishx/icons-svg/es/asn/PRotateRightOutlined";
import FishxIcon from '../components/FishxIcon';

var PRotateRightOutlined = function PRotateRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PRotateRightOutlinedSvg
  }));
};

PRotateRightOutlined.displayName = 'PRotateRightOutlined';
export default React.forwardRef(PRotateRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PRotateRightOutlined.js
// module id = 3605
// module chunks = 0